import React from 'react';

import './OtherPractices.css'

import otherPracticeImg from '../../assets/images/Home/other-pracitces.png'

const OherPractices = () => {

    const otherPracticesArr = [
        'Accounting services', 'Attorney at law', 'Corporate services', 'Drafting contracts', 'FinTech Services', 'Forex trading license', 'Financial license', 'Forex broker license', 'ICO consulting services', 'Investment', 'Opening an account in the payment system', 'Certificates of good standing, incumbency', 'Registration of trademarks', 'Tax consulting services', 'Valuation and business-modeling', 'Opening a cryptocurrency debit card', 'Citizenship', 'Ready-made cryptocurrency licenses for sale', 'Due diligence', 'Fintech Software Development', 'Gambling', 'International business certification', 'Investment in real estate', 'Legal Opinion', 'Opening merchant account', 'Redomicile of companies', 'Support IPO', 'Trust registration'
    ]

    const otherPracticesLeftArray = otherPracticesArr.slice(0, 14)
    const otherPracticesRightArray = otherPracticesArr.slice(14)

    return (
        <div className="other-practices-container">
                <div className="other-practices-left">
                    <h2 className="other-practices-title">
                        Other Practices
                    </h2>
                    <div className="other-practices-keys">
                        <div>
                            {otherPracticesLeftArray.map((el, index) => (
                                <div className="other-practices-items-left" key={index}>
                                    {el}
                                </div>
                            ))}
                        </div>
                        <div>
                            {otherPracticesRightArray.map((el, index) => (
                                <div className="other-practices-items-right" key={index}>
                                    {el}
                                </div>
                            ))}
                        </div>
                        
                        
                    </div>
                </div>
                <div className="other-practices-right">
                    <img  src={otherPracticeImg} alt="#" />
                </div>
            </div>
    );
};

export default OherPractices;